import { makeAutoObservable } from 'mobx';
import type { RootStore } from './root-store';

export class ConfirmStore {
    rootStore: RootStore;

    activeConfirmId: string | null = null;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;

        makeAutoObservable(this, {
            rootStore: false,
        });
    }

    setActiveConfirm(id: string) {
        this.activeConfirmId = id;
    }

    clearActiveConfirm() {
        this.activeConfirmId = null;
    }

    isActive(id: string): boolean {
        return this.activeConfirmId === id;
    }
}
